import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeDivisionRead from './cnaeDivisionRead.action.json' with { type: 'json' }

const cnaeDivisionReadDefinition = defineReadAutoAction(cnaeDivisionRead, 'cnaeDivision')

export default cnaeDivisionReadDefinition
